<template>
  <TextInputWithSelect
  :items="selectItems"
  v-bind="$attrs"
  v-on="$listeners"
  :menuProps="{
    top: isMobile,
  }"
  class="hour-picker"
  @select-input="handleSelectInput"
  @input="handleInput"
  :should-open-menu="openMenu"
  >
    <input
      ref="nativeInputElement"
      v-if="isMobile"
      class="native-time-input"
      @input="handleNativeInput"
      type="time"/>
    <slot/>
  </TextInputWithSelect>
  <!--  prepend-inner-icon="far fa-clock"-->
  <!--  clearable-->
  <!--  clear-icon="far fa-times-circle"-->
</template>

<script>
  import TextInputWithSelect from "@/modules/common/components/TextInputWithSelect/TextInputWithSelect.vue"
  import {convertTime12to24, convertTime24To12} from "@/modules/common/services/timeService.js"
  export default {
  components: {
    TextInputWithSelect,
  },
  props: {
    minutesInterval: {
      type: Number,
      default: 30,
    },
    amPmMode: {
      type: Boolean,
      required: true,
    },
    openMenu: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    '$attrs.value': {
      handler(newVal) {
        if(this.isMobile) {
          this.assignValueToNativeInput(newVal)
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      shouldFilter: true,
    }
  },
  created() {
    this.shouldFilter = !this.$attrs.value
  },
  methods: {
    filterFunc(value, item) {
      return !this.shouldFilter || !value || item.toString().toLowerCase().indexOf(value.toString().toLowerCase()) !== -1
    },
    handleSelectInput() {
      this.shouldFilter = false
    },
    handleInput(value) {
      this.shouldFilter = !!value
    },
    handleNativeInput(e) {
      let newValue = e.target.value
      if(this.amPmMode) {
        newValue = convertTime24To12(newValue)
      } else {
        newValue = convertTime12to24(newValue)
      }
      this.$emit('input', newValue)
    },
    async assignValueToNativeInput(val) {
      if(!this.$refs.nativeInputElement) {
        await this.$nextTick()
        return this.assignValueToNativeInput(val)
      }
      this.$refs.nativeInputElement.value = convertTime12to24(val)
    },
  },
  computed: {
    isMobile(){
      let res = this.$store ? this.$store.getters.isSmallScreen : !this.$vuetify.breakpoint.mdAndUp
      return !!res
    },
    selectItems() {
      var minutesInterval = this.minutesInterval;
      var times = []; // time array
      var startTime = 0; // start time
      var ap = ['AM', 'PM']; // AM-PM

      //loop to increment the time and push results in array
      let dayLengthInMinutes = 24*60
      for (let i=0; startTime < dayLengthInMinutes; i++) {
        var hh = Math.floor(startTime / 60); // getting hours of day in 0-24 format
        var mm = (startTime % 60); // getting minutes of the hour in 0-55 format
        if(this.amPmMode) {
          let hours = '';
          if(hh === 0 || hh === 12) {
            hours = '12'
          } else {
            hours = ("0" + (hh % 12)).slice(-2)
          }

          times[i] = hours + ':' + ("0" + mm).slice(-2) + ' ' + ap[Math.floor(hh / 12)]; // pushing data in array in [00:00 - 12:00 AM/PM format]
        } else {
          times[i] = `${hh.toString().padStart(2,0)}:${mm.toString().padStart(2,0)}`;
        }

        startTime = startTime + minutesInterval;
      }
      return times
    },
    brandBgColor() {
      return this.$store && this.$store.getters['brandModule/secondaryColor'];
    },

  }
}
</script>

<style lang="scss">
  .hour-picker {
    .native-time-input {
      z-index: 7;
      opacity: 0;
      position: absolute;
      top: 0;
      width: 100%;
      height: 100%;

    }
    .v-menu__content {
      max-height: 240px;
    }
    input {
      letter-spacing: -0.2px;
    }
    .v-input__prepend-inner, .v-input__append-inner {
      height: unset;
      width: unset;
      min-width: unset;
      i {
        font-size: 19px;
      }

    }
  }
</style>
